import { GET_PEOPLE_TO_VISIT, SET_FILTERS, SET_AMOUNT_OF_PEOPLE_TO_VISIT, SET_FETECHING, SET_PEOPLE_TO_VISIT_DATA, CRUD_PEOPLE_TO_VISIT, CLEAN_PEOPLE_TO_VISIT_ERROR, CHANGE_SETTING_LOCAL, CHANGE_SETTING, CLEAN_PEOPLE_TO_VISIT_STATE } from "./types";

const PeopleToVisitManagementReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_PEOPLE_TO_VISIT:
            return {
                ...state,
                peopleToVisitToConfig: payload.peopleToVisitToConfig,
                totalPages: payload.totalPages,
                isFetching: false,
                responsePeopleToVisitService: payload.responsePeopleToVisitService
            }
        case SET_FILTERS:
            return {
                ...state,
                filters: payload
            }
        case SET_AMOUNT_OF_PEOPLE_TO_VISIT:
            return {
                ...state,
                amountOfPeopleAllowed: payload.amountOfPeopleAllowed,
                responsePeopleToVisitService: payload.responsePeopleToVisitService
            }
        case CRUD_PEOPLE_TO_VISIT:
            return {
                ...state,
                isFetching: false,
                responsePeopleToVisitService: payload.responsePeopleToVisitService
            }
        case CLEAN_PEOPLE_TO_VISIT_STATE:
            return {
                ...state,
                amountOfPeopleAllowed: 0,
                personData: {
                    documentNumber: '',
                    name: '',
                    lastName: '',
                    openingCodes: [],
                    buildingIds: [],
                    sectorId: '',
                    enabled: 1
                },
                responsePeopleToVisitService: {
                    show: false,
                    type: '',
                    text: '',
                }
            }
        case SET_PEOPLE_TO_VISIT_DATA:
            return {
                ...state,
                isFetching: false,
                personData: payload,
            }
        case CLEAN_PEOPLE_TO_VISIT_ERROR:
            return {
                ...state,
                responsePeopleToVisitService: {
                    show: false,
                    type: '',
                    text: '',
                }
            }
        case CHANGE_SETTING:
            return {
                ...state,
                amountOfPeopleAllowed: payload.amountOfPeopleAllowed,
                responsePeopleToVisitService: payload.responsePeopleToVisitService,
                isFetching: false,
            }
        case SET_FETECHING:
            return {
                ...state,
                isFetching: payload,
            }
        case CHANGE_SETTING_LOCAL:
            return {
                ...state,
                openningsToConfig: payload,
            }
        default:
            return state;
    }
}

export default PeopleToVisitManagementReducer;